import React from 'react';
import './GSCFilter.scss';

export default props => (
  <div className='filter gsc-filter'>
    <span className='filter-type'>Showing only GSC keywords.</span>
    <button className='dismiss-standard' onClick={() => props.onDelete('gsc')}>Remove</button>
  </div>
)